import { Button } from '@cad-arc';
import { CSSProperties, MouseEventHandler } from 'react';
import { SelfAssignmentEvent } from '../fr-event-modals/unit-self-assignment-modal';
import { useFullscreenModalControls } from '../modals/context/modal-context-provider';

export function FrAssignButton({
    style,
    size,
    variant,
    hasAssignedUnits,
    selectedEvent,
    assignedEvent,
}: {
    style?: CSSProperties;
    size?: 'sm' | 'md' | 'lg' | 'xl';
    variant?: 'solid' | 'ghost' | 'outline';
    hasAssignedUnits: boolean;
    selectedEvent: SelfAssignmentEvent | undefined;
    assignedEvent: SelfAssignmentEvent | undefined;
}) {
    const modalControls = useFullscreenModalControls();

    const handleAssignUnit: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();

        if (selectedEvent) {
            modalControls.open({
                type: 'UNIT_SELF_ASSIGNMENT_MODAL',
                props: {
                    selectedEvent,
                    assignedEvent,
                },
            });
        }
    };

    return (
        <Button
            style={style}
            size={size}
            variant={variant}
            onClick={handleAssignUnit}
            data-testid="FR_ASSIGN_BUTTON"
        >
            {hasAssignedUnits ? 'Assist' : 'Assign Self'}
        </Button>
    );
}
